<nav>
  <ul class="breadcrumb-wrapper">
    <li class="breadcrumb-item">
      <a class="app-name" [routerLink]="['/']">
        <span class="app-name__full">RAIN MESH</span>
        <span class="app-name__short" aria-hidden="true">RM</span>
      </a>
    </li>
    @if (breadcrumbs.length > 0) {
      <app-icon [size]="IconSize.SM" name="ic_chevron_right"/>
      @for (bc of breadcrumbs; track bc.url; let last = $last) {
        <li
          [class.active]="last"
          class="breadcrumb-item"
        >
          @if (!last) {
            <a [routerLink]="bc.url">{{ bc.label | translate }}</a>
          } @else {
            <p>{{ bc.label | translate }}</p>
          }
        </li>
        @if (!last) {
          <app-icon name="ic_chevron_right"/>
        }
      }
    }
  </ul>
</nav>
